import pre from './pre';
import post from './post';
import config from './config.vue';
import cart from './cart.vue';
import success from './success.vue';
import addon from './addon.vue'

export default {
  pre,
  components: {
    config,
    cart,
    addon,
    success,
  },
  post,
};
